import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface OrderState {
 orderHeadTitle: string
 orderHeadFirstName: string
 orderHeadLastName: string
 orderHeadCompanyName: string
 orderHeadQuotationId: string
 orderHeadCustomerType: string
 orderHeadVatId: string
 orderHeadEmail: string
 deliveryTitle: string
 deliveryFirstName: string
 deliveryLastName: string
 deliveryCompanyName: string
 deliveryAddress1: string
 deliveryAddress2: string
 deliveryAddress3: string
 deliveryZipcode: string
 deliveryCity: string
 deliveryState: string
 deliveryCountry: string
 deliveryPhoneNumber: string
 deliveryEmail: string
 invoiceTitle: string
 invoiceFirstName: string
 invoiceLastName: string
 invoiceCompanyName: string
 invoiceAddress1: string
 invoiceAddress2: string
 invoiceAddress3: string
 invoiceZipcode: string
 invoiceCity: string
 invoiceState: string
 invoiceCountry: string
 invoicePhoneNumber: string
 invoiceEmail: string,
 orderMessage: string,
 assistantResponsibility: string,
 assistantInvoiceAddress: string,
}

/* const initialState: OrderState = {
 orderHeadTitle: 'mr',
 orderHeadFirstName: 'Janine',
 orderHeadLastName: 'Doe',
 orderHeadCompanyName: '',
 orderHeadQuotationId: '1234567',
 orderHeadCustomerType: 'private',
 orderHeadVatId: '',
 orderHeadEmail: 'john@doe.com',
 deliveryTitle: 'mrs',
 deliveryFirstName: 'Jolene',
 deliveryLastName: 'Dickus',
 deliveryCompanyName: '',
 deliveryAddress1: '2345 Mainstreet',
 deliveryAddress2: '',
 deliveryAddress3: '',
 deliveryZipcode: '12345',
 deliveryCity: 'Biggus-City',
 deliveryState: 'FL',
 deliveryCountry: 'DE',
 deliveryPhoneNumber: '0123456789',
 deliveryEmail: 'john@doe.com',
 invoiceTitle: 'mr',
 invoiceFirstName: 'John',
 invoiceLastName: 'Doe',
 invoiceCompanyName: '',
 invoiceAddress1: '6789 Second Street',
 invoiceAddress2: '',
 invoiceAddress3: '',
 invoiceZipcode: '12345',
 invoiceCity: 'Dickus Sickus',
 invoiceState: '',
 invoiceCountry: 'DE',
 invoicePhoneNumber: '',
 invoiceEmail: '',
 orderMessage: '',
 assistantResponsibility: 'self',
 assistantInvoiceAddress: 'self'
}; */

const initialState: OrderState = {
 orderHeadTitle: '',
 orderHeadFirstName: '',
 orderHeadLastName: '',
 orderHeadCompanyName: '',
 orderHeadQuotationId: '',
 orderHeadCustomerType: '',
 orderHeadVatId: '',
 orderHeadEmail: '',
 deliveryTitle: '',
 deliveryFirstName: '',
 deliveryLastName: '',
 deliveryCompanyName: '',
 deliveryAddress1: '',
 deliveryAddress2: '',
 deliveryAddress3: '',
 deliveryZipcode: '',
 deliveryCity: '',
 deliveryState: '',
 deliveryCountry: '',
 deliveryPhoneNumber: '',
 deliveryEmail: '',
 invoiceTitle: '',
 invoiceFirstName: '',
 invoiceLastName: '',
 invoiceCompanyName: '',
 invoiceAddress1: '',
 invoiceAddress2: '',
 invoiceAddress3: '',
 invoiceZipcode: '',
 invoiceCity: '',
 invoiceState: '',
 invoiceCountry: '',
 invoicePhoneNumber: '',
 invoiceEmail: '',
 orderMessage: '',
 assistantResponsibility: '',
 assistantInvoiceAddress: ''
};

export const orderSlice = createSlice({
 name: 'order',
 initialState,
 reducers: {
  setOrderInfo: (state, action: PayloadAction<OrderState>) => {
   return { ...state, ...action.payload }
  },
  resetOrderState: (state) => {
   Object.assign(state, initialState)
   /* console.log("Reset state"); */
  }
 }
})


export const { setOrderInfo, resetOrderState } = orderSlice.actions;

export default orderSlice.reducer